import { withCompInfo } from '@wix/editor-elements-integrations'
import { colorApi } from '@wix/thunderbolt-becky-root'
import { HeaderContainerCss, HeaderContainerDefinition } from './HeaderContainer'
import { getTopCSS, isFixedPosition } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<HeaderContainerCss, HeaderContainerDefinition>()(
	[
		'styleProperties',
		'compLayout',
		'siteColors',
		'compSingleLayout',
		// @ts-ignore - Remove once isOneDocMigrated is added to the compInfo
		'isOneDocMigrated',
	],
	({
		styleProperties,
		compLayout,
		siteColors,
		compSingleLayout,
		// @ts-ignore - Remove once isOneDocMigrated is added to the compInfo
		isOneDocMigrated,
	}) => {
		const fixedPosition = isFixedPosition(compLayout, compSingleLayout)
		const marginTop = getTopCSS(compLayout, compSingleLayout)
		const brightnessParams = colorApi.getBrightnessCSSVars({
			siteColors,
			styleProperties,
		})
		const style =
			(!isOneDocMigrated &&
				fixedPosition && {
					position: 'fixed !important' as const,
					'margin-top': 'var(--wix-ads-height)' as const,
					top: '0' as const,
				}) ||
			(!isOneDocMigrated &&
				marginTop !== '0px' && {
					'margin-top': marginTop,
				}) ||
			(isOneDocMigrated &&
				compSingleLayout?.itemLayout?.type !== 'FixedPositionItemLayout' && {
					position: 'relative',
				})

		return {
			...brightnessParams,
			...style,
		}
	}
)
